import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';
import {Button} from '@material-ui/core';
import {Form, Table, Glyphicon} from 'react-bootstrap';
import * as fields from 'components/common/fields';
import {makeForm} from 'utils/common';
import * as validators from 'utils/validators';

class BulkStudentsCreationForm extends React.Component {
  render() {
    const {idxList, fieldNames, onUserRemove, handleSubmit, submitting} = this.props;
    return (
      <Form onSubmit={handleSubmit} className="kluwell-table center-align">
        <Table hover responsive bordered condensed striped>
          <thead>
            <tr>
              {Object.entries(fieldNames).map(([name, text]) => (
                <th key={name} title={text}>
                  {text}
                </th>
              ))}
              <th />
            </tr>
          </thead>
          <tbody>
            {idxList.map((idx) => (
              <tr key={idx}>
                {Object.keys(fieldNames).map((name) => (
                  <td key={`${idx}-${name}`}>
                    <Field
                      name={`${idx}-${name}`}
                      component={fields.Input}
                      required
                      validate={[validators.isRequired]}
                    />
                  </td>
                ))}
                <td>
                  <a href={null}>
                    <Glyphicon glyph="remove" onClick={() => onUserRemove(idx)} />
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Button variant="contained" color="primary" type="submit" disabled={submitting}>
          Create Subscriptions
        </Button>
      </Form>
    );
  }
}

BulkStudentsCreationForm.propTypes = {
  idxList: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  fieldNames: PropTypes.object.isRequired,
  onUserRemove: PropTypes.func.isRequired,
};

export default makeForm(BulkStudentsCreationForm, 'BulkStudentsCreationForm', null, null);
